const frHome = {
  hero_h1_line1: "Hipobuy",
  hero_h1_line2: "Spreadsheet",
  hero_subtitle: "Le Guide Complet Pour Optimiser Vos Données",
  hero_desc: "Découvrez comment utiliser le hipobuy spreadsheet pour organiser, analyser et automatiser vos données efficacement.",

  value_title: "Pourquoi le Hipobuy Spreadsheet est essentiel en 2026",
  value_desc: "Dans un monde où les données gouvernent les décisions, le hipobuy spreadsheet s'impose comme l'outil incontournable pour les professionnels. Organisation des données, automatisation intelligente, suivi SEO et scalabilité business — tout est réuni dans une solution puissante et accessible.",
  value_bullet_1: "Optimisation des données avec hipobuy spreadsheet",
  value_bullet_2: "Suivi avancé des performances",
  value_bullet_3: "Automatisation des processus",
  value_bullet_4: "Analyse intelligente des résultats",
  value_bullet_5: "Compatible Google Sheets / Excel",

  categories_title: "Catégories",
  categories_title_highlight: "Produits",
  categories_subtitle: "Explorez notre sélection de catégories et trouvez exactement ce dont vous avez besoin.",
  categories_shop_now: "Shop Now",

  articles_title_line1: "Guides &",
  articles_title_line2: "Articles",
  articles_subtitle: "Ressources SEO",

  trust_tagline: "La Confiance",
  trust_title_line1: "Hipobuy",
  trust_title_line2: "Spreadsheet",
  trust_title_line3: "Performance",
  trust_subtitle: "Des résultats mesurables qui parlent d'eux-mêmes. Rejoignez des milliers d'utilisateurs satisfaits.",
  trust_stat_1_number: "98%",
  trust_stat_1_label: "Taux de satisfaction utilisateur. Nos clients recommandent le hipobuy spreadsheet pour sa fiabilité.",
  trust_stat_1_tagline: "Excellence vérifiée",
  trust_stat_2_number: "2000+",
  trust_stat_2_label: "Utilisateurs actifs quotidiens qui font confiance au hipobuy spreadsheet pour leurs données.",
  trust_stat_2_tagline: "Communauté grandissante",

  testimonial_tag: "Avis Vérifié",
  testimonial_title_line1: "Ce que nos",
  testimonial_title_line2: "utilisateurs disent",

  final_cta_title: "Optimisez vos données",
  final_cta_subtitle_line1: "Prêt à transformer votre gestion de données avec",
  final_cta_subtitle_line2: "le hipobuy spreadsheet ?",
  final_cta_button: "hipobuy spreadsheet",
  final_cta_secondary: "buy it now",
  final_cta_urgency: "Accès immédiat — Aucun engagement requis",

  comparison_title: "Comparaison des Solutions",
  comparison_subtitle: "Découvrez pourquoi le hipobuy spreadsheet est le meilleur choix pour vos données en 2026",
  comparison_col_solution: "Solution",
  comparison_col_ease: "Facilité",
  comparison_col_power: "Puissance",
  comparison_col_cost: "Coût",
  comparison_col_seo: "Valeur SEO",
  comparison_col_recommended: "Recommandé",
  comparison_row_1_solution: "Hipobuy Spreadsheet",
  comparison_row_1_ease: "⭐⭐⭐⭐",
  comparison_row_1_power: "⭐⭐⭐⭐⭐",
  comparison_row_1_cost: "Gratuit/Pro",
  comparison_row_1_seo: "Très élevé",
  comparison_row_1_recommended: "Oui",
  comparison_row_2_solution: "Excel",
  comparison_row_2_ease: "⭐⭐⭐⭐",
  comparison_row_2_power: "⭐⭐⭐⭐",
  comparison_row_2_cost: "Payant",
  comparison_row_2_seo: "Moyen",
  comparison_row_2_recommended: "Partiel",
  comparison_row_3_solution: "Notion",
  comparison_row_3_ease: "⭐⭐⭐",
  comparison_row_3_power: "⭐⭐⭐",
  comparison_row_3_cost: "Gratuit",
  comparison_row_3_seo: "Moyen",
  comparison_row_3_recommended: "Non",
};

export default frHome;